import React, { useContext, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { RecordingContext } from "../pages/RecordingPage";
import { Form, Comment, Header } from "semantic-ui-react";
import { selectCommentsForRecording } from "../../selectors";
import { commentCreate } from "../../actions/commentAction";

const RecordingComments = () => {
  const dispatch = useDispatch();
  const { recording, commentRef } = useContext(RecordingContext);
  const comments = useSelector((state) =>
    selectCommentsForRecording(state.comments, recording)
  );
  const [comment, setComment] = useState("");

  useEffect(() => {
    setComment("");
  }, [recording]);

  return (
    <Comment.Group>
      <Header as={"h3"} dividing content="Comments" />
      {comments.map((comment) => (
        <Comment key={comment.id}>
          <Comment.Avatar src="/avatar.png" />
          <Comment.Content>
            <Comment.Author as="a" content={comment.user_name} />
            <Comment.Metadata>
              <div>{moment(comment.created_at).fromNow()}</div>
            </Comment.Metadata>
            <Comment.Text>{comment.text}</Comment.Text>
          </Comment.Content>
        </Comment>
      ))}
      <Form>
        <div style={{ display: "flex", alignItems: "center" }}>
          <textarea
            rows={2}
            ref={commentRef}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
          />
          <Form.Button
            primary
            floated="right"
            content="Add Comment"
            disabled={!comment}
            onClick={() => {
              dispatch(commentCreate(recording.id, comment));
            }}
          />
        </div>
      </Form>
    </Comment.Group>
  );
};

export default RecordingComments;
